interface ElementsSelectableParams {
  isViewOnlyMode: boolean;
  isViewer: boolean;
  isPublic: boolean;
}

export const areElementsSelectable = ({
  isViewOnlyMode,
  isViewer,
  isPublic,
}: ElementsSelectableParams) => {
  // In viewer or public mode, elements are selectable by default
  // Note: The actual selectable state of individual nodes is controlled by ConvertCanvasSchemaForReactFlow
  // This function only determines if selection is possible at all
  if (isViewer || isPublic) return true;

  // If view only mode and not viewer/public, not selectable
  if (isViewOnlyMode) return false;

  // Default case: elements are selectable
  return true;
};
